import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import ProfileBioSection from './ProfileBioSection';
import { getAllCanadianCityOptions } from '../../../utils/canadianCities';
import { useLanguage } from '../../../contexts/LanguageContext';

const CandidateQualificationForm = ({ formData, errors, onChange }) => {
  const { t } = useLanguage();

  const experienceOptions = [
    { value: '0-2', label: '0-2 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '6-10', label: '6-10 years' },
    { value: '10+', label: '10+ years' },
  ];

  const industryOptions = [
    { value: 'tech', label: 'Technology' },
    { value: 'construction', label: 'Construction' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'finance', label: 'Finance' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'manufacturing', label: 'Manufacturing' },
  ];

  const seniorityOptions = [
    { value: 'senior', label: 'Senior Professional' },
    { value: 'lead', label: 'Lead/Principal' },
    { value: 'manager', label: 'Manager' },
    { value: 'director', label: 'Director' },
    { value: 'vp', label: 'VP/Executive' },
    { value: 'c-level', label: 'C-Level' },
  ];

  const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'French' },
    { value: 'bilingual', label: 'Bilingual (EN/FR)' },
  ];

  const locationOptions = getAllCanadianCityOptions();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl md:text-2xl font-semibold text-[#111827] mb-2">
          {t('accessRequest.qualificationTitle')}
        </h3>
        <p className="text-sm md:text-base text-[#6B7280]">
          {t('accessRequest.qualificationSubtitle')}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={t('accessRequest.fullName')}
          type="text"
          placeholder="Enter your full name"
          value={formData?.fullName || ''}
          onChange={(e) => onChange('fullName', e?.target?.value)}
          error={errors?.fullName}
          required
        />

        <Input
          label={t('accessRequest.email')}
          type="email"
          placeholder="your.email@example.com"
          value={formData?.email || ''}
          onChange={(e) => onChange('email', e?.target?.value)}
          error={errors?.email}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label={t('accessRequest.experience')}
          placeholder="Select experience range"
          options={experienceOptions}
          value={formData?.experience || ''}
          onChange={(value) => onChange('experience', value)}
          error={errors?.experience}
          required
        />

        <Select
          label={t('accessRequest.industry')}
          placeholder="Select your industry"
          options={industryOptions}
          value={formData?.industry || ''}
          onChange={(value) => onChange('industry', value)}
          error={errors?.industry}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label={t('accessRequest.seniority')}
          placeholder="Select your level"
          options={seniorityOptions}
          value={formData?.seniority || ''}
          onChange={(value) => onChange('seniority', value)}
          error={errors?.seniority}
          required
        />

        <Select
          label={t('accessRequest.language')}
          placeholder="Select language"
          options={languageOptions}
          value={formData?.language || ''}
          onChange={(value) => onChange('language', value)}
          error={errors?.language}
          required
        />
      </div>
      <Select
        label={t('accessRequest.location')}
        placeholder="Select location"
        options={locationOptions}
        value={formData?.location || ''}
        onChange={(value) => onChange('location', value)}
        error={errors?.location}
        searchable
        required
      />
      <Input
        label={t('accessRequest.linkedinUrl')}
        type="url"
        placeholder="https://linkedin.com/in/yourprofile"
        description="Optional - helps us verify your experience"
        value={formData?.linkedinUrl || ''}
        onChange={(e) => onChange('linkedinUrl', e?.target?.value)}
      />
      <ProfileBioSection
        formData={formData}
        errors={errors}
        onChange={onChange}
      />
      <div className="pt-4 border-t border-[#E5E7EB]">
        <Checkbox
          label={t('accessRequest.confirmExperience')}
          checked={formData?.experienceConfirmed || false}
          onChange={(e) => onChange('experienceConfirmed', e?.target?.checked)}
          error={errors?.experienceConfirmed}
          required
        />
      </div>
      <div>
        <Checkbox
          label={t('accessRequest.confirmDiscretion')}
          checked={formData?.discretionConfirmed || false}
          onChange={(e) => onChange('discretionConfirmed', e?.target?.checked)}
        />
      </div>
    </div>
  );
};

export default CandidateQualificationForm;